//jshint esversion: 9
import Vue from 'vue';
import Vuex from 'vuex';

import * as getters from './getters';
import * as actions from './actions';
import * as mutations from './mutations';
import bill from './modules/newbill';
import caja from './modules/caja';
import pendientes from './modules/pendientes';
import promos from './modules/promos';
import inventario from './modules/inventario';

//Data modules 
import clientesData from './modules/demo_data/clientesData';
import usersData from './modules/demo_data/usersData';
import ventasData from './modules/demo_data/ventasData';
import serviciosData from './modules/demo_data/serviciosData';
import productosData from './modules/demo_data/productosData';
import categoriasData from './modules/demo_data/categoriasData';
import settingsData from './modules/demo_data/settingsData';
import promosData from './modules/demo_data/promosData';

let dbPath = '';

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    cloudConnection: false,
    apiUrl: 'http://laundrySystem-API.localhost',//'http://localhost/Laundry-System-API'
    // localMedia: app.getPath('userData'), //app.getPath('appData'),
    dbUri: dbPath,
    db: null,
    categorias: [],
    servicios: [],
    productos: [],
    currentUser: null,
    invoicesToCharge: [],
    unauthNavAttemptUrl: null,
    newClientWasAdded: null,
    isChargeBillModalOpen: false,
    isEntregarServicioModalOpen: false,
    loadingIndicator: false,
    successModal: false,
    successModalMessage: "",
    invoiceDetailDialog: false,
    invoiceDetailsItem: null,
    printConfirmDialog: false,
    navDatePickerModal: false,
  },
  getters,
  mutations,
  actions,
  modules: {
    bill,
    caja,
    pendientes,
    promos,
    inventario,
    clientesData,
    usersData,
    ventasData,
    serviciosData,
    productosData,
    categoriasData,
    settingsData,
    promosData
  }
});
